import axios from 'axios';

const baseUrl = '/accounts';

export default {
  getAccountMembers() {
    return axios.get(`${baseUrl}/users`);
  },
  create(payload) {
    return axios.post(`${baseUrl}/create`, payload);
  },
  inviteUser(payload) {
    return axios.post(`${baseUrl}/user/invite`, payload);
  },
  completeInvite(payload) {
    return axios.post(`${baseUrl}/user/add`, payload);
  },
  removeUser({ userId }) {
    return axios.delete(`${baseUrl}/user/${userId}`);
  },
  forgottenPassword(payload) {
    return axios.post(`${baseUrl}/user/forgotten-password`, payload);
  },
  resetPassword(payload) {
    return axios.post(`${baseUrl}/user/reset-password`, payload);
  },
  changePassword(payload) {
    return axios.post(`${baseUrl}/user/change-password`, payload);
  },
};
